import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { CardLayout, BreadCrumb } from './containers/Layout.jsx';
import Form from './returns/Form.jsx';
import { Button, Card, Grid, Box } from '@material-ui/core';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import StockListReturn from './returns/StockListReturn.jsx';
import SwipeableTabs from '../../../commonModules/MUI/SwipeableTabs.jsx';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@material-ui/lab';
import { ArrowBackIosRounded, Favorite, ReceiptRounded, UndoRounded } from '@material-ui/icons';
import ListTransferOccasionSale from './transfers/returns/ListTransferOccasionSale.jsx';
import ListTransferReturn from './transfers/returns/ListTransferReturn.jsx';
import NewReturnProduct from './transfers/returns/Forms/NewReturnProduct.jsx';

class Returns extends Component{
    state = {
        view: "list",
        // singleSAV:{},
        singleShop:{},
        singleProd:{},
        breadcrumb:"",
        mainbreadcrumb:"",
        sav:{ },
        headerMenu: "ALL",
        showSingleProd: false,
        showSingleShop: false
        // notif:{
        //     title:"", 
        //     type:"", 
        //     message:"",
        //     show:false,
        // },
        
    }
    
    componentDidMount = () => {
        console.log("MOUNTING RETURNS ");
        
        this.props.getAllReturnProducts()
        this.loadSalesIfNeeded();
    }

    componentDidUpdate = (prevProps, prevState) => {
        // Charger les ventes quand on ouvre le formulaire "Nouveau Retour" (au cas où le fetch n'était pas terminé)
        if (this.state.view === "new" && prevState.view !== "new" && isEmpty(this.props.SALES)) {
            this.loadSalesIfNeeded();
        }
    }

    loadSalesIfNeeded = () => {
        if (isEmpty(this.props.SALES)) {
            this.props.fetchTranferTypes("vente");
        }
    }
    handleSearch = async (e) => {
        const field = e.target.name
        const value = e.target.value
        await this.setState({
            ...this.state,
            search:{
                ...this.state.search,
                [field]:e.target.value
            }
        })
        const vType= (this.state.search.searchType).toLowerCase()
        // const vShop= (this.state.search.searchShop).toLowerCase()

        console.log("[INFO] handleSearch type ", vType);

        let match = []
        if( this.props.SALES){
            await  this.props.allSales.map((sale, index) => {// find sale that match search options
                if( (vType !== "" && sale.nature === vType) || vType === "" ){
                    match.push(sale)
                } 
            })
        }
        console.log("[INFO] handleSearch match result ",match);
        this.setState({
            ...this.state,
            sales:match
        })

        
    }
       
    // CLEAR & DISPLAY
        handleDelete = async (item) => {
            try{
                const response = await fetch('/stocks/single',{
                    method:'DELETE',
                    headers:{ 
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                    },
                    body:JSON.stringify({
                        id : item.id
                    }),
                    credentials: 'same-origin',
                }); 
                const body = await response.json();
                this.setState({
                    ...this.state,
                    stocks:[
                        ... this.props.STOCKS.slice(0,item.index),
                        ... this.props.STOCKS.slice(item.index +1)
                    ]
                })

            } catch(err){
                console.log(err);   
            }
        }

        
        handleClose = () => {
            this.setState({
                view:"list",
                mainbreadcrumb:"",
                breadcrumb:"",
                showSingleProd: false,
                showSingleShop: false
            });
        }
        // handleSingleProd = (prod) => {
        //     this.setState({
        //         breadcrumb: prod.name,
        //         singleProd:prod,
        //         view: "product"
        //     })
        // }
        // handleSingleShop = (shop) => {
        //     this.setState({
        //         breadcrumb: shop.name,
        //         singleShop:shop,
        //         view: "shop"
        //     })

        // }
        handleSingleProd = (prod) => {
            this.setState({
                breadcrumb: prod.name,
                singleProd:prod,
                showSingleProd: true
            })
        }
        handleSingleShop = (shop) => {
            this.setState({
                breadcrumb: shop.name,
                singleShop:shop,
                showSingleShop: true
            })
    
        }

    render(){
        console.log("[STATE] Returns ", this.state);
        const { PRODUCTS, SHOPS } = this.props
        const { headerMenu } = this.state;

     
        return(
            <CardPage 
                title="Magasin Occasion"
                storehouse
                action={this.state.view === "list" &&
                    <Box>
                        {/* <Box p={1}>
                            <Button 
                                color="primary" variant="contained"
                                onClick={ () => this.setState({view: "new", mainbreadcrumb:"Nouveau"}) }
                            >
                                Nouveau Retour
                            </Button>

                        </Box>
                        <Box p={1}>
                            <Button 
                                color="secondary" variant="contained"
                                onClick={ ()=> this.setState({view: "newSale", mainbreadcrumb:"Nouveau"}) }
                            >
                                Nouvelle Vente
                            </Button>
                        </Box> */}

                        <div>
                        {/* <div className={classes.exampleWrapper}> */}
                            <SpeedDial
                                ariaLabel="SpeedDial example"
                                // className={classes.speedDial}
                                icon={<SpeedDialIcon />}
                                onClose={() => this.setState({ openSpeedDial: false})}
                                onOpen={() => this.setState({ openSpeedDial: true})}
                                open={this.state.openSpeedDial}
                                direction={"left"}
                                // color="secondary"
                                // FabProps={{
                                //     sx: {
                                //       bgcolor: 'secondary.main',
                                //       '&:hover': {
                                //         bgcolor: 'secondary.main',
                                //       }
                                //     }
                                //   }}
                                // CHANGE COLOR Not working
                            >
                                <SpeedDialAction
                                    key="Nouveau Retour"
                                    icon={<UndoRounded />}
                                    // ButtonProps={{ color: "primary" }} // CHANGE COLOR Not working
                                    tooltipTitle="Nouveau Retour"
                                    // tooltipOpen
                                    onClick={() => this.setState({view: "new", mainbreadcrumb:"Nouveau", openSpeedDial: false})}
                                />
                                <SpeedDialAction
                                    key="Nouvelle Vente"
                                    icon={<ReceiptRounded />}
                                    // ButtonProps={{ color: "secondary" }} // CHANGE COLOR Not working
                                    tooltipTitle="Nouvelle Vente"
                                    // tooltipOpen
                                    onClick={() => this.setState({view: "newSale", mainbreadcrumb:"Nouveau", openSpeedDial: false})}
                                />
                            
                            </SpeedDial>
                        </div>

                    </Box>
                }
            >
                <BreadCrumb breadcrumb={this.state.mainbreadcrumb} title="Retours" back={this.handleClose} />

                {this.state.view === "new" &&
                    <NewReturnProduct
                        {...this.props} 
                        handleClose={this.handleClose} 
                        // notif={this.notif}
                    />
                }
                {this.state.view === "newSale" &&
                    <Form 
                        {...this.props} 
                        handleClose={this.handleClose} 
                        // notif={this.notif}
                    />
                }
                {this.state.view === "list" &&
                    <SwipeableTabs
                        labels={["Inventaire", "Entrées", "Sorties"]}
                        default="Inventaire"
                    >
                        <StockListReturn 
                            {...this.props} 
                            handleSingleShop={this.handleSingleShop}
                            handleSingleProd={this.handleSingleProd}
                            handleClose={this.handleClose}
                             
                        />
                        <ListTransferReturn 
                            // {...this.props}
                            {...this.state}
                            handleSingleShop={this.handleSingleShop}
                            handleSingleProd={this.handleSingleProd}
                            handleClose={this.handleClose}
                            />
                        {/* <ReturnSaleList  */}
                        <ListTransferOccasionSale
                            {...this.props} 
                            {...this.state} 
                            handleSingleShop={this.handleSingleShop}
                            handleSingleProd={this.handleSingleProd}
                            handleClose={this.handleClose}
                        />
                    </SwipeableTabs>
                }
                {/* {(this.state.view === "product" && !isEmpty(this.state.singleProd)) &&
                    <div>
                        <SingleProduct 
                            {...this.props} 
                            product={this.state.singleProd}
                            close={this.handleClose}
                            occasion
                        />
                    </div>
                } */}
                
            </CardPage>

        )
    }
}


export default Returns;